<script setup>
import GenericDataFieldsWrapper from './GenericDataFieldsWrapper.vue';
import TagsDataFields from './TagsDataFields.vue';

const emit = defineEmits(['update', 'validation', 'show-tag-info']);

const props = defineProps({
  initialTagFields: {
    type: Array,
    default: () => ([]) // Inicia vazio, tags são opcionais
  },
  isEditMode: {
    type: Boolean,
    default: false
  }
});

// Array de títulos de tags que devem ser excluídas
// DEVE SER O MESMO ARRAY QUE ESTÁ EM TagsDataFields.vue
const EXCLUDED_TAG_TITLES = [
  'audio', 'atendimento-humano'
];
</script>

<template>
  <GenericDataFieldsWrapper
    :initial-fields="initialTagFields"
    :is-edit-mode="isEditMode"
    field-type="tag"
    :child-component="TagsDataFields"
    store-getter="labels/getLabels"
    store-action="labels/get"
    :excluded-titles="EXCLUDED_TAG_TITLES"
    add-button-label="Adicionar Configuração de Etiqueta"
    @update="(fields) => emit('update', fields)"
    @validation="(isValid) => emit('validation', isValid)"
    @show-info="() => emit('show-tag-info')"
  />
</template>